// extracted by mini-css-extract-plugin
module.exports = {"error":"NoImage_error__Y1usx","text":"NoImage_text__n0UpF"};